export const composeMicrosoftTeamsId = contact => {
  if (contact) {
    if (contact?.profile?.givenName && contact?.profile?.surname)
      return `${contact?.profile?.givenName}.${contact?.profile?.surname}`.toLowerCase();
  }
  return null;
};
